/* src/app/modules/members/add-member/add-member.component.scss */
.cover-photo-holder {
  max-width: 400px;
}
.form-row {
  width: 100%;
}
.form-row mat-form-field {
  width: 100%;
  padding: 10px;
}
.form-row mat-form-field input {
  width: 100%;
}
/*# sourceMappingURL=add-member.component.css.map */
